import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '../store/useAuthStore';
import { usePersistedAuthStore } from '../store/usePersistedAuthStore';
import { useUserStore } from '../store/useUserStore';
import { useTenantStore } from '../store/useTenantStore';

export const useLogout = () => {
  const navigate = useNavigate();

  const logout = (clearTenant = false) => {
    // Clear all auth data
    useAuthStore.getState().clearAuth();
    usePersistedAuthStore.getState().clearPersistedAuth();
    useUserStore.getState().clearUserInfo();
    
    // Clear tenant if requested (for changing organization)
    if (clearTenant) {
      useTenantStore.getState().clearTenant();
      navigate('/org-code');
    } else {
      // Keep tenant info so user doesn't need to re-enter org code
      const hasValidTenant = useTenantStore.getState().hasValidTenant();
      navigate(hasValidTenant ? '/login' : '/org-code');
    }
  };

  return logout;
};